import { render, staticRenderFns } from "./CrmLayout.vue?vue&type=template&id=2bb19294&scoped=true&"
import script from "./CrmLayout.vue?vue&type=script&lang=js&"
export * from "./CrmLayout.vue?vue&type=script&lang=js&"
import style0 from "./CrmLayout.vue?vue&type=style&index=0&id=2bb19294&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb19294",
  null
  
)

component.options.__file = "CrmLayout.vue"
export default component.exports